const ACTIVITY_CODE_LENGTH = 7;
const SEPARATORS: Readonly<Record<number, string>> = { 4: '-', 5: '/' };

/** Remove a máscara: só os 7 primeiros dígitos do CNAE (subclasse). */
export function unmaskActivityCode(value: string): string {
  return value.replace(/\D/g, '').slice(0, ACTIVITY_CODE_LENGTH);
}

/** Aplica a máscara de CNAE `0000-0/00` progressivamente. */
export function maskActivityCode(value: string): string {
  const digits = unmaskActivityCode(value);
  let masked = '';
  for (let index = 0; index < digits.length; index += 1) {
    masked += `${SEPARATORS[index] ?? ''}${digits.charAt(index)}`;
  }
  return masked;
}
